export default __webpack_public_path__ + "static/media/easybill.6d9bc124.svg";